import { transition } from '@helpers/animate';
import { imageCoverContainer } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { Device, from, until } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.button `
  ${ButtonReset}

  ${transition('background-size, color')}

  display: inline-flex;
  flex-shrink: 0;
  column-gap: 15px;
  color: var(--colorFg);
  background-color: var(--colorBg);
  background-image: linear-gradient(to right, var(--colorBgActive), var(--colorBgActive));
  background-repeat: no-repeat;
  background-size: var(--bgSize);
  border: 1px solid var(--colorBorder);
  border-radius: 30px;
  ${fonts.altGothicNo2.regular}
  font-size: 20px;
  height: 55px;
  line-height: 1em;

  place-content: center;
  place-items: center;
  text-transform: uppercase;

  text-align: center;

  @media (hover: hover) or (pointer: fine) {
    &:hover {
      background-size: var(--bgSizeActive);
      border-color: var(--colorBorderActive);
      color: var(--colorFgActive);
    }
  }

  &[aria-current='true'] {
    background-size: var(--bgSizeActive);
    border-color: var(--colorBorderActive);
    color: var(--colorFgActive);
  }

  &[data-theme='light'] {
    --bgSize: 0% 100%;
    --colorFg: ${brand.black};
    --colorBg: ${brand.white};
    --colorBorder: ${brand.black};

    --bgSizeActive: 100% 100%;
    --colorFgActive: ${brand.black};
    --colorBgActive: ${brand.yellow};
    --colorBorderActive: ${brand.black};
  }

  &[data-theme='dark'] {
    --bgSize: 0% 100%;
    --colorFg: ${brand.yellow};
    --colorBg: ${brand.black};
    --colorBorder: ${brand.yellow};

    --bgSizeActive: 100% 100%;
    --colorFgActive: ${brand.black};
    --colorBgActive: ${brand.yellow};
    --colorBorderActive: ${brand.yellow};
  }

  &[data-theme='outline'] {
    --bgSize: 0% 100%;
    --colorFg: ${brand.black};
    --colorBg: transparent;
    --colorBorder: ${brand.black};

    --bgSizeActive: 100% 100%;
    --colorFgActive: ${brand.black};
    --colorBgActive: ${brand.yellow};
    --colorBorderActive: ${brand.yellow};
  }

  &.focus-ring {
    outline: auto;
    outline-color: ${brand.white};
    outline-offset: 5px;
    outline-width: thin;
  }

  @media ${from(Device.TabletLarge)} {
    &:not([data-variant='small']) {
      padding: 8px;
      padding-right: 40px;
      height: 81px;
      border-radius: 43px;
    }
  }
`;
const AvatarWrapper = styled.div `
  position: relative;
  border-radius: 50%;
  height: ${fluid(65, 65)};
  width: ${fluid(65, 65)};
  overflow: hidden;
  @media ${until(Device.TabletLarge)} {
    display: none;
  }

  @media ${from(Device.TabletLarge)} {
    ${Container}[data-variant='small'] & {
      display: none;
    }
  }
`;
const Avatar = styled.img `
  ${imageCoverContainer()}
`;
const ContentContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 2px;
`;
const ContentName = styled.span `
  ${fonts.altGothicNo2.regular}
  font-size: 18px;
  text-transform: uppercase;
  line-height: 1;

  @media ${from(Device.TabletLarge)} {
    font-size: 22px;
  }

  @media ${from(Device.TabletLarge)} {
    ${Container}[data-variant='small'] & {
      font-size:18px;
    }
  }
`;
const ContentLocation = styled.span `
  ${fonts.altGothicNo2.regular}
  font-size: 14px;
  text-transform: uppercase;
  line-height: 1;

  @media ${from(Device.TabletLarge)} {
    font-size: 16px;
  }

  @media ${from(Device.TabletLarge)} {
    ${Container}[data-variant='small'] & {
      font-size: 14px;
    }
  }
`;
const TabButtonStyles = {
    Container,
    AvatarWrapper,
    Avatar,
    ContentContainer,
    ContentLocation,
    ContentName,
};
export default TabButtonStyles;
